import React from 'react';
import { Box, CircularProgress, Tooltip, Typography } from '@mui/material';

/** Where a session's post-training analysis stands (backend `analysisStatus`). */
export type AnalysisStatus = 'pending' | 'completed' | 'failed' | 'not_scoreable';

const COPY = {
  processing: 'Processing…',
  notScored: 'Not scored',
  notScoredHint: 'The rep did not speak in this session, so there was nothing to grade.',
  failed: 'Analysis failed',
  failedHint: 'Open the session and use Re-run Analysis to try again.',
} as const;

/**
 * What a sessions-list cell shows when there is no value to print. Only an
 * analysis that is still running spins; one that finished without a score
 * (not_scoreable) or failed says so, instead of "Processing…" forever.
 */
export const AnalysisStatusCaption: React.FC<{ analysisStatus?: AnalysisStatus | null }> = ({ analysisStatus }) => {
  if (analysisStatus === 'not_scoreable' || analysisStatus === 'failed') {
    const isNotScoreable = analysisStatus === 'not_scoreable';
    return (
      <Tooltip title={isNotScoreable ? COPY.notScoredHint : COPY.failedHint}>
        <Typography variant="caption" color="text.secondary" data-testid="analysis-status-caption">
          {isNotScoreable ? COPY.notScored : COPY.failed}
        </Typography>
      </Tooltip>
    );
  }
  return (
    <Box display="flex" alignItems="center" gap={0.75}>
      <CircularProgress size={12} />
      <Typography variant="caption" color="text.secondary">{COPY.processing}</Typography>
    </Box>
  );
};

export default AnalysisStatusCaption;
